import { Button, Dropdown } from "react-bootstrap";
import LogoutIcon from "../components/svg/LogoutIcon";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/context/useAuth";
import { useLayout } from "../hooks/context/useLayout";
import useModules from "../hooks/services/profile/useModules";

type ProfileActionsProps = { show: boolean };

const ProfileActions = ({ show }: ProfileActionsProps) => {
  const { logout } = useAuth();
  const { closeSideBar } = useLayout();
  const { modules } = useModules();

  const onLogout = async () => {
    await closeSideBar();
    logout();
  };

  return (
    <Dropdown.Menu align="end" show={show}>
      {modules
        .filter((module) => !module.fromSideBar)
        .map((module) => (
          <Dropdown.Item key={module.name} as={Link} to={module.path} onClick={closeSideBar}>
            {module.Icon && <module.Icon />}
            {module.name}
          </Dropdown.Item>
        ))}
      <Dropdown.Item as={Button} onClick={onLogout}>
        <LogoutIcon />
        Logout
      </Dropdown.Item>
    </Dropdown.Menu>
  );
};
export default ProfileActions;
